import {useLocation, useHistory} from 'react-router-dom'

export default () => {
  const location = useLocation()
  const history = useHistory()
  const searchParams = new URLSearchParams(location.search)
  const modalString = searchParams.get('modals') || ''
  const modalStack = modalString ? modalString.split(',') : []

  const pushModal = (name, params = {}) => {
    // add or move name to end (top) of stack
    const newStack = [...modalStack.filter(n => n !== name), name]
    searchParams.set('modals', newStack.join(','))
    Object.entries(params).forEach(([key, value]) => searchParams.set(key, value))
    history.push({pathname: location.pathname, search: searchParams.toString()})
  }

  const popModal = (name, params = []) => {
    const newStack = modalStack.filter(modalName => modalName !== name)
    if (newStack.length) {
      searchParams.set('modals', newStack.join(','))
    } else {
      searchParams.delete('modals')
    }
    params.forEach(param => searchParams.delete(param))
    history.push({pathname: location.pathname, search: searchParams.toString()})
  }

  return {
    ...Object.fromEntries(searchParams.entries()),
    searchParams,
    modalStack,
    pushModal,
    popModal
  }
}
